import Axios from 'axios';

// 初始化默认post header
Axios.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8';

const responseInterceptors = [
  (res) => {
    const { data, status } = res;
    if (status !== 200) {
      throw Error(status);
    }
    if (!data.success) {
      throw Error(data.errorMessage); // error.message打印错误信息
    }
    return data.result;
  },
  (error) => {
    Promise.reject(error);
  },
];
// axios 实例化
function createAxios(config) {
  // 默认配置
  const baseConfig = {
    baseURL: '',
    timeout: 60000,
    // withCredentials: true,
    // headers: {
    //   sysCode: 'crm',
    // },
  };
  const cconfig = Object.assign(baseConfig, config);
  const instanceAxios = Axios.create(cconfig);
  instanceAxios.interceptors.response.use(...responseInterceptors);
  return instanceAxios;
}
const request = createAxios();
export default request;
